{
  "version": 1,
  "asset_id": "ec316cb9-5348-453f-adc5-06a95b954a02",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/ec316cb9-5348-453f-adc5-06a95b954a02/renovatie-1024.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/ec316cb9-5348-453f-adc5-06a95b954a02/renovatie-1024.avif",
  "original_filename": "renovatie-1024.avif",
  "size": 24820,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:40Z"
}
